import { createMMKV } from 'react-native-mmkv';

// MMKV storage instance shared by the hub experiences. The id predates the
// move out of sales-portal — keep it so persisted state survives the move.
export const experienceStorage = createMMKV({
  id: 'sales-portal-storage',
});

export const STORAGE_KEYS = {
  COPILOT_SESSION: 'copilot_session',
  FULFILLMENT_MAP: 'fulfillment_map',
  NAVIGATION_STATE: 'navigation_state',
  PRICING_AGENT_ACTIONS: 'pricing_agent_actions',
  PRICING_EDITS: 'pricing_edits',
  UI_STATE: 'ui_state',
};
